module.exports = {
    '0101106': 'error0101106',
    '0101126': 'error0101126',
    '0201001': 'error0201001',
    '0201002': 'error0201002',
    '0201003': 'error0201003',
    '0201004': 'error0201004',
    '0201005': 'error0201005',
    '0201006': 'error0201006',
    '0201007': 'error0201007',
    '0201008': 'error0201008',
    '0201009': 'error0201009',
    '0201010': 'error0201010',
    '0201011': 'error0201011',
    '0201012': 'error0201012',
    '0201013': 'error0201013',
    '0201014': 'error0201014',
    '0201022': 'error0201022',
    '0201114': 'error0201114',
    '0201116': 'error0201116',
    '0201117': 'error0201117',
    '0202001': 'error0202001',
    '0202011': 'error0202011',
    '0203001': 'error0203001',
    '0203002': 'error0203002',
    '0203003': 'error0203003',
    '0203004': 'error0203004',
    '0203005': 'error0203005',
    '0203201': 'error0203201',
    '0203202': 'error0203202',
    '0203203': 'error0203203',
    '0201018': 'error0201018',
    '0201019': 'error0201019',
    '0201020': 'error0201020',
    '0203204': 'error0203204',
    '0203205': 'error0203205',
    '0203206': 'error0203206',
    '0203006': 'error0203006',
    '0201023': 'error0201023',
    '0999999': 'error0999999'
};